import { Check, CheckCircle2, Pencil } from "lucide-react";
import { L } from "@/i18n";

const LETTERS = "ABCDEFGH";

export const DuplicateItem = ({ item, differs, selected, disabled, onToggle, onKeepOnly, onEdit }) => (
  <div
    className={`flex flex-col rounded-md border p-4 transition-colors ${
      selected ? "border-rose-500/60 bg-rose-500/5" : "border-slate-800 bg-[#0f172a]"
    }`}
    data-testid={`duplicate-item-${item.id}`}
  >
    <div className="flex items-start gap-3">
      <button
        type="button"
        onClick={onToggle}
        disabled={disabled && !selected}
        aria-pressed={selected}
        data-testid={`duplicate-select-${item.id}`}
        className={`mt-0.5 h-4 w-4 shrink-0 rounded border grid place-items-center transition-colors disabled:opacity-30 ${
          selected ? "bg-rose-500 border-rose-500" : "border-slate-600 hover:border-amber-500"
        }`}
        aria-label={L("Mark for deletion", "Marcar para eliminar")}
      >
        {selected && <Check className="h-3 w-3 text-white" />}
      </button>
      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-center gap-2 font-mono text-[11px]">
          <span className="rounded bg-amber-500/10 px-2 py-0.5 text-amber-400">{item.module_title}</span>
          {item.source && <span className="text-slate-500 truncate">{item.source}</span>}
          {differs && (
            <span className="rounded border border-sky-500/40 bg-sky-500/10 px-1.5 py-0.5 text-sky-300" data-testid={`duplicate-differs-${item.id}`}>
              {L("Differs", "Diferente")}
            </span>
          )}
        </div>
        <p className="mt-1 font-mono text-[10px] text-slate-600 truncate">{item.id}</p>
      </div>
    </div>
    <ol className="mt-3 space-y-1.5 text-xs">
      {item.options?.map((opt, i) => {
        const correct = i === item.correct_option;
        return (
          <li key={i} className={`flex gap-2 rounded px-2 py-1.5 ${correct ? "bg-emerald-500/10 text-emerald-200" : "text-slate-300"}`}>
            <span className={`font-mono ${correct ? "text-emerald-400" : "text-slate-500"}`}>{LETTERS[i]}</span>
            <span className="flex-1">{opt}</span>
            {correct && <CheckCircle2 className="h-3.5 w-3.5 shrink-0 text-emerald-400" />}
          </li>
        );
      })}
    </ol>
    <p className="mt-3 text-xs text-slate-400">
      {item.explanation || <span className="italic text-slate-600">{L("No explanation recorded.", "Sem explicação registada.")}</span>}
    </p>
    <div className="mt-auto pt-3 flex items-center justify-between gap-3">
      <button
        type="button"
        onClick={onKeepOnly}
        className="text-[11px] text-amber-400 hover:text-amber-300"
        data-testid={`duplicate-keep-only-${item.id}`}
      >
        {L("Keep only this one", "Manter só esta")}
      </button>
      <button
        type="button"
        onClick={() => onEdit(item)}
        className="flex items-center gap-1 rounded border border-slate-700 px-2 py-0.5 text-[11px] text-slate-300 hover:border-amber-500/60 hover:text-amber-400 transition-colors"
        data-testid={`duplicate-edit-${item.id}`}
      >
        <Pencil className="h-3 w-3" /> {L("Edit", "Editar")}
      </button>
    </div>
  </div>
);
